import React from 'react';

const MenuStateContext = React.createContext<boolean>(false);

export default MenuStateContext;
